/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesDocumentsDtosDocumentDto,
  GetApiV1DocumentsParams,
  PostApiV1DocumentsBody
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getDocuments = () => {
/**
 * @summary Upload a file and attach it to a customer or object.
 */
const postApiV1Documents = (
    postApiV1DocumentsBody: PostApiV1DocumentsBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesDocumentsDtosDocumentDto>>,) => {const formData = new FormData();
if(postApiV1DocumentsBody.file !== undefined) {
 formData.append(`file`, postApiV1DocumentsBody.file)
 }
if(postApiV1DocumentsBody.ownerType !== undefined) {
 formData.append(`ownerType`, postApiV1DocumentsBody.ownerType)
 }
if(postApiV1DocumentsBody.ownerId !== undefined) {
 formData.append(`ownerId`, postApiV1DocumentsBody.ownerId)
 }
if(postApiV1DocumentsBody.description !== undefined) {
 formData.append(`description`, postApiV1DocumentsBody.description)
 }
if(postApiV1DocumentsBody.tags !== undefined) {
 formData.append(`tags`, postApiV1DocumentsBody.tags)
 }

      return customInstance<FacilityFlowCoreModulesDocumentsDtosDocumentDto>(
      {url: `/api/v1/documents`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary List the documents attached to a customer or object.
 */
const getApiV1Documents = (
    params?: GetApiV1DocumentsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesDocumentsDtosDocumentDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesDocumentsDtosDocumentDto[]>(
      {url: `/api/v1/documents`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Download a document's content.
 */
const getApiV1DocumentsIdContent = (
    id: string,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/documents/${id}/content`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Delete a document (removes both the metadata and the stored blob).
 */
const deleteApiV1DocumentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/documents/${id}`, method: 'DELETE'
    },
      options);
    }
  return {postApiV1Documents,getApiV1Documents,getApiV1DocumentsIdContent,deleteApiV1DocumentsId}};
export type PostApiV1DocumentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDocuments>['postApiV1Documents']>>>
export type GetApiV1DocumentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDocuments>['getApiV1Documents']>>>
export type GetApiV1DocumentsIdContentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDocuments>['getApiV1DocumentsIdContent']>>>
export type DeleteApiV1DocumentsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDocuments>['deleteApiV1DocumentsId']>>>
